/* eslint-disable */
import React, { PropTypes } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ReactModal from 'react-modal';
import Alert from 'react-s-alert';
import * as campanhaActions from './actions/campanhaActions'
import RatingEmoji from './RatingEmoji'
import RatingStar from './RatingStar'
import RatingNps from './RatingNps'
import RatingNumerico from './RatingNumerico'
import Helpers from './util/Helpers'
import ConfigD from './util/ConfigD';
import './css/modal.css'
import './css/Rating.css'
import Erro from './Erro';


//CSS para radio
//https://gist.github.com/rcotrina94/7828886
class RatingPerguntaForm extends React.Component {

    constructor(props, context) {
        super(props, context);
        
        this.state = {
            imagemSelecionada:'',
            textoImgSelecionada:'',
            imagemClicada:'',
            showModal: false,
            txtMensagem:'',
            reiniciarPagina:false,
            token: !$.isEmptyObject(this.props.params) && this.props.params.token ? this.props.params.token : null,
            erro:null,
            tipoCampanha: !$.isEmptyObject(this.props.params) && this.props.params.tipo ? this.props.params.tipo : '1',
            idCampanha: !$.isEmptyObject(this.props.params) && this.props.params.idCampanha ? this.props.params.idCampanha : null,
            perguntaCampanha:null
        }
        this.mouseOverImg = this.mouseOverImg.bind(this);
        this.mouseOutImg = this.mouseOutImg.bind(this);
        this.clickImg = this.clickImg.bind(this);
      }
      

    onChangeTxtMensagem(e){
        this.setState({txtMensagem:e.target.value});
    }
    
    reiniciarPagina () {
        this.setState({ 
            imagemSelecionada:'', 
            imagemClicada:'',
            textoImgSelecionada:'',
            txtMensagem:'',
            reiniciarPagina:true
        });
        //window.location.reload()
    }

    mouseOverImg(val){
        this.setState({imagemSelecionada:val, textoImgSelecionada:this.props.pergunta.mTipoCampanhaPergunta===1?'Nota: '+val:Helpers.obteTextoEmoji(val)});
    }

    mouseOutImg(){
        this.setState({
            imagemSelecionada:this.state.imagemClicada!==''?this.state.imagemClicada:'',
            textoImgSelecionada:this.state.imagemClicada!==''?this.props.pergunta.mTipoCampanhaPergunta===1?
            'Nota: '+this.state.imagemClicada: 
            Helpers.obteTextoEmoji(this.state.imagemClicada):
            ''
        });
    }

    clickImg(val, perguntaRespondida){
        
        $(this.refs.errMensagem).hide();
        this.setState({reiniciarPagina:false})
        this.setState({imagemSelecionada:val, imagemClicada:val, textoImgSelecionada:this.props.pergunta.mTipoCampanhaPergunta===1?'Nota: '+val:Helpers.obteTextoEmoji(val)});
        this.props.clickImg(val, perguntaRespondida);
    }

 

    render() {
        
        if (!$.isEmptyObject(this.state.erro)){
            return <Erro mensagemErro={this.state.erro} />
        }

        var rating = '';
        //console.log('posicao', this.props.idPosicao)
        if(this.props.pergunta.mTipoCampanhaPergunta===1){
            rating = <RatingStar pergunta={this.props.pergunta} mouseOverImg={this.mouseOverImg} mouseOutImg={this.mouseOutImg} clickImg={this.clickImg} reiniciarPagina={this.props.reiniciarPagina}/>;
        }else if(this.props.pergunta.mTipoCampanhaPergunta===2){
            rating = <RatingEmoji pergunta={this.props.pergunta} mouseOverImg={this.mouseOverImg} mouseOutImg={this.mouseOutImg} clickImg={this.clickImg} reiniciarPagina={this.props.reiniciarPagina}/>;
        }else if(this.props.pergunta.mTipoCampanhaPergunta===3){
            rating = <RatingNps pergunta={this.props.pergunta} mouseOverImg={this.mouseOverImg} mouseOutImg={this.mouseOutImg} clickImg={this.clickImg} reiniciarPagina={this.props.reiniciarPagina} voto={this.props.idPosicao===0?this.props.voto:11}/>;
        }else{
            rating = <RatingNumerico pergunta={this.props.pergunta} mouseOverImg={this.mouseOverImg} mouseOutImg={this.mouseOutImg} clickImg={this.clickImg} reiniciarPagina={this.props.reiniciarPagina} voto={this.props.idPosicao===0?this.props.voto:11}/>;
            
        }
        //console.log('pergunta', this.props.pergunta)
        
        //console.log('pergunta ', this.state.perguntaCampanha)
        
        
        var textoImgSelecionada = ''//<h3 className='subTitle'style={{ display: this.props.pergunta.mTipoCampanhaPergunta !== '3' ? 'visible' : 'none' }}> <strong>{this.state.textoImgSelecionada}</strong></h3>

        return (


            <div className="input-block">
            
                <div className='label labelPesquisa' >
                    <a href={'#'+this.props.idPosicao} id={'idPosicao'+this.props.idPosicao}/>
                    {this.props.pergunta.mPergunta}
                </div>
                        {rating}
            </div>
        );
    }
}
RatingPerguntaForm.contextTypes = {
    router: React.PropTypes.object
};

function mapStateToProps(state, ownProps){
    
    return {
        campanha: state.campanha
    };
}

function mapDispatchToProps(dispatch){
   return {
        
       actions: bindActionCreators(campanhaActions, dispatch)
    };
    
}

export default connect(mapStateToProps, mapDispatchToProps)(RatingPerguntaForm);





/** WEBPACK FOOTER **
 ** ./src/components/RatingPerguntaForm.js
 **/